import { formatPrice } from '@general/helpers';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function addProductToRecentlyViewed(productHandle) {
  let recentlyViewed = getCookie('recently_viewed')
    ? JSON.parse(getCookie('recently_viewed'))
    : [];

  if (!recentlyViewed.includes(productHandle)) {
    recentlyViewed.push(productHandle);
  }

  if (recentlyViewed.length > 8) {
    recentlyViewed.shift();
  }

  setCookie('recently_viewed', JSON.stringify(recentlyViewed), 30);
}

function displayRecentlyViewed() {
  const recentlyViewed = getCookie('recently_viewed')
    ? JSON.parse(getCookie('recently_viewed'))
    : [];

  const section = document.querySelector('.recently-viewed__section');

  if (recentlyViewed.length > 0) {
    section.style.display = 'block';

    const container = document.querySelector(
      '.recently-viewed__list-container .carousel__slider-wrapper .swiper-wrapper',
    );

    container.innerHTML = '';

    recentlyViewed.forEach((handle) => {
      fetch(`/products/${handle}.js`)
        .then((response) => response?.json())
        .then((product) => {
          const firstVariant = product.variants[0];

          const comparePrice = formatPrice({
            value: firstVariant.compare_at_price,
          });

          const price = formatPrice({
            value: firstVariant.price,
          });

          const mediaHTML = product.images
            .slice(0, 2)
            .map(
              (image, index) => `
              <div class='swiper-slide'>
                <a href="${product.url}" class="product-tile__gallery-link">
                <div class="media__container product-tile__gallery-media-${index + 1}">
                  <img
                    src="${image}&width=520"
                    alt="${product.title}"
                    class="product-tile__gallery-media-${index + 1}"
                  />
                </div>
                </a>
              </div>
              `,
            )
            .join('');

          const tagsHTML = product.tags
            .map((item) =>
              item.includes('TAG__')
                ? `<div class="product-tile__tags-label">${item.replace(/^TAGS?__/, '')}</div>`
                : '',
            )
            .join('');

          const labelHTML = product.tags
            .map((item) =>
              item.includes('LABEL__')
                ? `<div class="product-tile__tags-label">${item.replace(/^LABEL?__/, '')}</div>`
                : '',
            )
            .join('');

          const productHTML = `
          <div class="swiper-slide">
            <div class="product-tile__container">
            <div class="product-tile__gallery">
              <div class='swiper-wrapper'>
                ${mediaHTML}
              </div>
              <div class='product-tile__tags--top'>
                ${tagsHTML}
              </div>
              </div>
              <div class="product-tile__info">
                <div class="product-tile__meta">
                  <a href="${product.url}" class="product-tile__title">
                    <p>${product.title}</p>
                  </a>
                </div>

                <div class='product-tile__tags--bottom'>
                  ${labelHTML}
                </div>

                <div class="product-tile__price" ${window.SHOPPABLE_MARKET ? '' : 'style="display: none;"'}>
                  ${firstVariant.compare_at_price && firstVariant.price < firstVariant.compare_at_price ? `<del data-compare-at-price>${comparePrice}</del>` : ''}
                  <span data-price>${price}</span>
                </div>

              </div>
            </div>
          </div>
          `;

          container.insertAdjacentHTML('beforeend', productHTML);
        })
        .then(() => {
          container
            .querySelectorAll('.product-tile__container')
            .forEach((tile) => {
              window.dAgency.initProductTile(tile);
            });

          const carouselContainer = document.querySelector(
            '.recently-viewed__list-container .carousel__container',
          );

          if (
            carouselContainer &&
            typeof window.dAgency.initCarousel == 'function'
          ) {
            window.dAgency.initCarousel(carouselContainer);
          }
        });
    });
  } else {
    section.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const productContainer = document.querySelector('.product-page__section');
  const cartPageContainer = document.querySelector('.cart-page__container');
  if (productContainer || cartPageContainer) {
    const url = window.location.pathname;
    const productHandle = url.split('/').pop();

    if (productHandle) {
      addProductToRecentlyViewed(productHandle);
    }

    displayRecentlyViewed();
  }
});
